export default {
  title: {
    id: 'bo_sellers-orders-drawers-refund_order-modal_title',
    defaultMessage: 'Refund order',
  },
  prompt: {
    id: 'bo_sellers-orders-drawers-refund_order-info_message',
    defaultMessage:
      'Are you sur you want to refund {sku} from order {orderId}?',
  },
  amount: {
    id: 'bo_sellers-orders-drawers-refund_order-amount',
    defaultMessage: 'Amount to refund',
  },
  shipping: {
    id: 'bo_sellers-orders-drawers-refund_order-shipping',
    defaultMessage: 'Shipping',
  },
  tax: {
    id: 'bo_sellers-orders-drawers-refund_order-tax',
    defaultMessage: 'Tax',
  },
  message: {
    id: 'bo_sellers-orders-drawers-refund_order-message_to_customer',
    defaultMessage: 'Your message to your customer',
  },
  confirm: {
    id: 'bo_sellers-orders-drawers-refund_order-refund_order',
    defaultMessage: 'Yes, refund this order',
  },
  cancel: {
    id: 'bo_sellers-orders-drawers-refund_order-dont_refund',
    defaultMessage: "No, don't refund",
  },
  successMessage: {
    id: 'bo_sellers-orders-drawers-refund_order-order_refunded',
    defaultMessage: 'Order refunded',
  },
  required: {
    id: 'bo_sellers-orders-drawers-refund_order-required',
    defaultMessage: 'This field is required',
  },
}
